import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';

import { Autosuggest, FormField, Link, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAlert, mdiDownloadBoxOutline, mdiFile, mdiFileCloud, mdiFileExcelBox, mdiFilePdfBox, mdiFilePowerpointBox, mdiFileWordBox, mdiFolderOutline, mdiZipBox } from '@mdi/js';
import Icon from '@mdi/react';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading } from '../../../../commons/functions';

interface ItemDocument {
  id: number;
  idFolder: number;
  idFile: number;
  idParent: number;
  name: string;
  content: string;
  type: string;
  iconName: string;
  extension: string;
  fileSize: number;
  dateCreated: string;
  timeCreated: string;
  nestedItems?: ItemDocument[];
}

interface ItemBreadcrumbs {
  text: string;
  href: string;
}
const root = "#members/etc/docs";
export const MembersEtcDocsPage = () => {
  const { menu } = useGlobalState();



  const [documents, setDocuments] = useState<ItemDocument[]>([]);
  const [folders, setFolders] = useState<ItemDocument[]>([]);
  const [masterFolders, setMasterFolders] = useState<ItemDocument[]>([]);
  const [route, setRoute] = useState<ItemBreadcrumbs[]>([{ text: "Inicio", href: root }]);

  const [idFolder, setIdFolder] = useState<number>(0);
  const [keyword, setKeyword] = useState<string>("");


  const handleGetFolder = async (idFolder: number) => {
    //
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/documents/folders/get',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({ idFolder: idFolder })
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.documents) {
        setDocuments(data.documents);
        //setRoute([{ text: "Inicio", href: "#members/etc/docs" }, ...newRoute]);


      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetDocuments = async () => {

    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/documents/list',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({})
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.documents) {
        setMasterFolders(data.documents);
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (idFile: number, filename: string) => {
    try {
      setLoading(true);

      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          // Ensure your server handles the request with JSON body
          'Content-Type': 'application/json',
          'x-routing': '/private/user/documents/files/download',
          'JWT': getCookie("JWT"),
        },
        body: JSON.stringify({
          idFile: idFile
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      // 1. Get the binary data as a Blob
      const blob = await response.blob();

      // 2. Create a temporary URL for the downloaded binary data
      const url = window.URL.createObjectURL(blob);

      // 3. Create a temporary anchor element
      const a = document.createElement('a');

      // 4. Set the download attributes and simulate a click
      a.href = url;
      // The 'download' attribute forces the browser to save the file
      a.download = filename;

      document.body.appendChild(a);
      a.click(); // Programmatically click the link to trigger the download

      // 5. Clean up the temporary elements and URL
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error during file download:', error);
      // You might want to update global messages or notifications here
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      if (id !== null)
        setIdFolder(id ? parseInt(id) : 0);
      else
        setIdFolder(43486)
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);


  useEffect(() => {

    if (idFolder > 0) {
      handleGetFolder(idFolder)
      const breadcrumbs = buildBreadcrumbPath(masterFolders, idFolder);
      setRoute(breadcrumbs)
    }
  }, [idFolder, folders, masterFolders]);

  useEffect(() => {
    //console.log("handleGetDocuments")
    handleGetDocuments()
  }, []);
  useEffect(() => {
    //const [filteredDocs] = filterTree(documents, keyword);
    //setNewDocuments(filteredDocs);
  }, [keyword]);
  const [
    expandedItems,
    setExpandedItems
  ] = React.useState<ItemDocument[]>([]);




  const filteredDocuments = keyword.length > 1
    // Check if the trimmed keyword is 2 characters or more, OR if searchWords has any content
    ? masterFolders.filter(folder => {
      const searchWords = keyword.trim().toLowerCase().split(/\s+/).filter(Boolean);
      // Prepare the folder name outside the loop for slight performance gain
      const folderNameLower = folder.name.trim().toLowerCase();

      const matchesKeyword = searchWords.every(word =>
        folderNameLower.includes(word)
      );
      return matchesKeyword;
    })
    : [];
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <SpaceBetween size="s">
            <Header variant="h1" actions={<><Favorites /></>}>Documentos</Header>
            <BreadcrumbGroup items={route}

            />
            <Table
              wrapLines
              filter={

                <Autosuggest
                  hideEnteredTextOption
                  disableBrowserAutocorrect
                  onSelect={(event) => {
                    const item = masterFolders.find((folder) => folder.id === Number(event.detail.selectedOption?.value))
                    //console.log(item)
                    if (item && event) {
                      window.location.hash = `${root}?id=${item?.idFolder}`
                      setKeyword("");
                    }
                  }}
                  filteringType="manual"
                  onChange={({ detail }) => setKeyword(detail.value)}
                  value={keyword}
                  options={filteredDocuments.map((item) => ({
                    value: item.id.toString(),
                    label: item.name
                  }))}
                  placeholder="Buscar documentos por palabras clave"
                />
              }
              stickyHeader
              variant='embedded'
              columnDefinitions={[
                {
                  id: 'icon',
                  header: '',
                  cell: item => item.type === "folder" ? <Icon path={mdiFolderOutline} size={1} /> :
                    item.extension === "pdf" ? <Icon path={mdiFilePdfBox} size={1} /> :
                      item.extension === "doc" || item.extension === "docx" ? <Icon path={mdiFileWordBox} size={1} /> :
                        item.extension === "xls" || item.extension === "xlsx" ? <Icon path={mdiFileExcelBox} size={1} /> :
                          item.extension === "zip" || item.extension === "rar" ? <Icon path={mdiZipBox} size={1} /> :
                            item.extension === "cup" || item.extension === "igc" ? <Icon path={mdiFileCloud} size={1} /> :
                              item.extension === "ppt" || item.extension === "pptx" ? <Icon path={mdiFilePowerpointBox} size={1} /> : <Icon path={mdiFile} size={1} />

                  ,
                  maxWidth: 50,
                  width: 50,
                },
                {
                  id: 'name',
                  header: 'Nombre',
                  cell: item => item.type === "folder" ? (<Link variant="secondary" href={`${root}?id=${item.idFolder}`}><strong>{item.name}</strong></Link>) :
                    item.fileSize === 0 ? (<em><Icon path={mdiAlert} size={1} color={"red"} />{" "}{item.name}</em>)
                      :
                      (<>{item.name}</>)
                  ,
                },
                {
                  id: 'size',
                  header: 'Tamaño',
                  cell: item => item.type === "folder" ? "" : `${item.fileSize} KB`,
                  width: 50,
                },
                {
                  id: 'date',
                  header: 'Fecha',
                  cell: item => item.type === "folder" ? "" : <FormField label={item.dateCreated}>{item.timeCreated}</FormField>,
                  width: 120,
                },
                {
                  id: 'download',
                  header: '',
                  cell: item => item.type === "folder" ? "" :
                    item.fileSize === 0 ? "" :
                      (
                        <Link variant="secondary" onClick={() => {
                          //console.log(item)
                          handleDownload(item.idFile, item.name);
                        }}>
                          <Icon path={mdiDownloadBoxOutline} size={1} />
                        </Link>),
                  width: 50,
                },
              ]} items={documents}
            />


          </SpaceBetween>
        </>
      }
    />
  );
};


function buildBreadcrumbPath(folders: any[], targetId: number) {
  const map = new Map(folders.map(f => [f.id, f]));
  const path = [];
  let current = map.get(targetId);
  while (current) {
    path.unshift({ text: current.name, href: `${root}?id=${current.id}` });
    current = map.get(current.idParent);
  }

  return path;
}